import React from "react";

const FiltresAnimaux = ({ annonces, filters, onChange }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updatedFilters = { ...filters };

    if (type === "checkbox") {
      updatedFilters[name] = checked
        ? [...(filters[name] || []), value]
        : filters[name].filter((v) => v !== value);
    } else {
      updatedFilters[name] = value;
    }

    onChange(updatedFilters);
  };

  const uniqueEspeces = [...new Set(annonces.map((a) => a.espece).filter(Boolean))];

  return (
    <div>
      <h3>Espèce</h3>
      {uniqueEspeces.map((espece) => (
        <label key={espece}>
          <input
            type="checkbox"
            name="espece"
            value={espece}
            onChange={handleChange}
          />
          {espece}
        </label>
      ))}

      <h3>Prix</h3>
      <label>
        Min:
        <input
          type="number"
          name="prixMin"
          value={filters.prixMin}
          onChange={handleChange}
          placeholder="Prix minimum"
        />
      </label>
      <label>
        Max:
        <input
          type="number"
          name="prixMax"
          value={filters.prixMax}
          onChange={handleChange}
          placeholder="Prix maximum"
        />
      </label>
    </div>
  );
};

export default FiltresAnimaux;
